import Comments from './_Comments'
import Pickadate from './_Pickadate'
import PlacesTodo from './_PlacesTodo'
import Recurrent from './_Recurrent'
import ErrorElement from './_ErrorElement'
import Pdca from './_Pdca'

export default { Comments, Pickadate, PlacesTodo, Recurrent, ErrorElement, Pdca }
